import type { PublicConfig } from "@/config/public-config";

export interface SentryEnvOptions {
  maskAllText: boolean;
  blockAllMedia: boolean;
  tracesSampleRate: number;
}

// Per-environment Sentry settings. Production pages show buyer names, phones
// and addresses, so error replays there must mask all text and media; tracing
// is off to stay inside the free-tier quota. Staging/local keep unmasked
// replays and full tracing for debugging.
export function sentryOptionsFor(env: PublicConfig["SENTRY_ENVIRONMENT"]): SentryEnvOptions {
  if (env === "production") {
    return { maskAllText: true, blockAllMedia: true, tracesSampleRate: 0 };
  }
  return { maskAllText: false, blockAllMedia: false, tracesSampleRate: 1.0 };
}
